"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

// https://gist.github.com/DominikAngerer/dc9c7735021c13a4a05ee4752e3591ce
// https://forum.storyblok.com/t/cors-and-assets/282/7
// using storyblok assets add theme to page as json file
// Current blob size limit is around 500MB for browsers
var jsonSbAsset = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
    var s3Domain, res;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // use the direct S3 domain
            s3Domain = url.replace('a.storyblok', 's3.amazonaws.com/a.storyblok');
            _context.prev = 1;
            _context.next = 4;
            return fetch(s3Domain, {
              headers: new Headers({
                Origin: window.location.origin
              }),
              mode: 'cors'
            });

          case 4:
            res = _context.sent;
            return _context.abrupt("return", res.json());

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            throw new Error(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function jsonSbAsset(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _default = jsonSbAsset;
exports.default = _default;